/* eslint-disable */

/**
 * New consumers: prefer squareup.franklin.ui.UiAvatar.
 *
 * Data used to draw an Avatar component. This is generated from CustomerRenderData and
 * AvatarRenderData using paymentHistory.js for a particular Customer or Payment.
 * It can represent a Customer, Merchant, Transaction, Transfer, etc.
 *
 * Spec: https://docs.google.com/document/d/19JXrv1Ik96dPxDRIT-iIyvp_d-Giv1ziP_ROcorMPDc/edit#
 */
export interface Avatar {
  /** Optional image to render. Can be a customer photo, business logo, or category icon. */
  image_url?: string;
  /** Optional character to render in the Avatar if the `image_url` is null. */
  initial?: string;
  /**
   * The color to be used for fill. If not provided, this is derived by hashing the customer token
   * and mapping the value to a preset list of Colors in paymentHistory.js.
   */
  accent_color?: string;
  /**
   * If the image loaded from image_url should be color shifted.
   * Currently this means converting the color pixels to white, while preserving the alpha channel.
   */
  colorize_image?: boolean;
  /** Optional image to render in dark mode. */
  dark_theme_image_url?: string;
  /** The color to be used for fill in dark mode. */
  dark_theme_accent_color?: string;
  /** The shape to render the avatar with. Supported in clients 3.88+. Optional; default value `CIRCLE`. */
  shape?: AvatarShape;
}

export enum AvatarShape {
  CIRCLE = "CIRCLE",
  SQUARE = "SQUARE",
  SQUIRCLE = "SQUIRCLE",
}
